require('../../modules/es.object.define-properties');
var path = require('../../internals/path');

var Object = path.Object;

var defineProperties = module.exports = function defineProperties(T, D) {
  return Object.defineProperties(T, D);
};

if (Object.defineProperties.sham) defineProperties.sham = true;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/object/define-properties.js
// module id = 4737
// module chunks = 25